import copy from "copy-text-to-clipboard";
import { Notify } from "quasar";
import { computed, ref } from "vue";

export default function useClipboard() {
  const copied = ref(false);

  function copyToClipboard(data) {
    copy(data);
    copied.value = true;

    Notify.create({ message: "Copied to clipboard!", color: "green" });

    setTimeout(() => {
      copied.value = false;
    }, 1500);
  }

  const copyIcon = computed(() => (copied.value ? "check" : "file_copy"));

  return {
    copyToClipboard,
    copyIcon,
  };
}
